// extracted by mini-css-extract-plugin
export default {"black":"#000","primary":"#49aada","orange":"#eb9412","root":"QExVfBMXTdq0au1d2nih","ticket":"Cz3ue0PtZky2nMnf3Xxl","hidden":"b1WLk_CYuTuaCd0q0l0x"};